import React, {
    useEffect,
    useMemo,
    useState,
    useCallback,
    useRef,
  } from "react";
  import styled from "styled-components";
  import PlayWorkSheet from "./Play";
  import { Input } from "antd";
  import { useAlert } from "components/UI/alertSakeBar/alertProvider";
  
  import { IconButton, Typography } from '@mui/material';
  import { Edit, KeyboardArrowDown, CopyAllOutlined } from '@mui/icons-material';
  import { useCurrentUser } from "store/users/selectors";
  import { useDispatch } from "react-redux";
  import { setWorksheetView } from "store/worksheetView/action";
  import { useWorkSheetSelector } from "store/worksheet/selectors";
  import {
    handleListQuestionOfWorksheet,
    handleUpdateWorksheetName,
    handleDeleteWorksheet,
    handleUnshareWorksheet,
    handleCloneWorksheet,
    handleListWorkSheet,
    handleRemoveWorkSheet,
    handleGetWorksheetAssignedClassIds,
  } from "store/worksheet/thunks";
  import { fetchShareListAssignment } from "store/activities/thunks";
  import Loading from "components/Loading";
  import { Delete } from '@mui/icons-material';
  import { DeleteModal } from "components/Dialog";
  import { Dropdown, Select, Space, Tooltip } from "antd";
  import { useResources, useVideos } from "store/resources/selectors";
  import { useAllBook } from "store/books/selectors";
  import { getBookDisplayName, imageFetch } from "utils/lib/ebookHelper";
  import ActivityFormWorksheet from "./Assignment/AssignmentForm";
  import { useClassGameActivity } from "store/one_game/selectors";
  import { useCurrentClass } from "store/classes/selectors";
  import { useClassSubmissions } from "store/submissions/selectors";
  import dayjs from 'utils/dayjsConfig';
  import { handleLearningModuleCount } from "store/bingo/thunks";
  import { handleGetClass } from "store/classes/thunks";
  import { useUserClasses } from "store/userClasses/selectors";
  import { useAllDistrictTeacher } from "store/users/selectors";
  import ShareNotesList from "modules/shareNotes/shareNotesList";
  import ShareAction from "modules/shareNotes/shareAction";
  import shareIconSvg from "../../utils/assets/images/shareIcon.svg";
  import titleIconSvg from "../../utils/assets/images/titleIcon.svg";
  import trashIconSvg from "../../utils/assets/images/trashIcon.svg";
  import eyeBtnSvg from "../../utils/assets/images/eyeBtn.svg";
  import statusSvg from "../../utils/assets/images/status.svg";
  import clockSvg from "../../utils/assets/images/Clock.svg";
  import dueDateSvg from "../../utils/assets/images/dueDate.svg";
  import SharedAndAssignedTask from "../../components/SharedAndAssigned";
  import SentryWrap from 'components/Sentry';
  import CloneActivityToPageModal from 'components/CloneActivityToPageModal';
  import { handleGetSumissionById, handleListUserSubmissionsByClass } from "store/submissions/thunks";
  import { handleSubmitWorksheetAssignment } from "store/activities/thunks";
  import { GrammarDrillCover } from "../../utils/assets/images";
  import lastSubSvg from "../../utils/assets/images/last-sub.svg";
  import pastDueSvg from "../../utils/assets/images/pastDue.svg";
  import { useUI } from "store/UI/selectors";
  import { updateUI } from "store/UI/actions";
  import { useGetRedirectUrlForBook } from "containers/hooks";
  import { useNavigate } from "react-router-dom";
  import { useWorksheetView } from "store/worksheetView/selector";
  import { WorkSheetPrint } from "./printWorkSheet";
  import { useIsTab, useMobileDetect } from "containers/chat/hooks";
  
  const MainSection = styled.div`
    margin-bottom: ${({ $isLastWorksheetActivity, isAssigned }) =>
      $isLastWorksheetActivity && !isAssigned ? "0" : "16px"};
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 25px;
  `;
  
  const GradeText = styled.span`
      color: #000;
      font-size: 10.5px;
      font-style: normal;
      line-height: normal;
      white-space: nowrap;
  `;
  const Section = styled.div`
    background: #fff;
    border: 2px solid ${({ isDueDatePassed }) => isDueDatePassed ? "#f00" : "purple"};
    border-radius: 11px;
    position: relative;
    padding: 12px 12px 10px 30px;
    display: flex;
    flex-direction: column;
    min-height: 195px;
    &::before {
      width: 20px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      background: ${({ isDueDatePassed }) => isDueDatePassed ? "#f00" : "purple"};
      content: "";
      border-radius: 8px 0px 0px 8px;
    }
  `;
  const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 1;
  `;
  const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    flex: 1;
  `;
  const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: 12px;
  `;
  const TitleIcon = styled.img`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  `;
  const BodyImg = styled.div`
    width: 100%;
    height: 100px;
    flex: 1;
    background: transparent;
    background-size: cover;
    background-position: 50% 23%;
    background-repeat: no-repeat;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap:10px;
  `;
  const AssignmentInfoRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-top: 10px;
  `;
  const AssignmentInfoLeft = styled.div`
    flex: 1;
    min-width: 0;
  `;
  const BookCover = styled.img`
    height: ${(props) => props.isTeacher ? "55px" : "57px"};
    width: auto;
    object-fit: cover;
    background: #fff;
    flex-shrink: 0;
    margin-bottom: 5px;
  `;
  const FooterActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding-top: 3px;
    margin-top: auto;
    border-top: 1px solid rgba(136, 173, 226, 0.45);
    flex-wrap: wrap;
  `;
  const FooterRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  `;
  const StatusBadges = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  `;
  const SharedByBadge = styled.div`
    max-width: 130px;
    padding: 4px 10px;
    border-radius: 8px;
    background: #5ba857;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `;
  const AssignedBadge = styled.div`
    padding: 4px 10px;
    border-radius: 8px;
    background: #df3b22;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
  `;
  const AssignmentTypeBanner = styled.div`
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
  `;
  const AssignmentTypeName = styled.span`
      padding: 3px 3px;
      border-radius: 5px;
      border: 1px solid black;
      /* background: purple; */
      color: purple;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.02em;
      box-shadow: 0 0px 3px purple;
      white-space: nowrap;
  `;
  const HeaderTitle = styled.p`
      color: ${({ isDueDatePassed }) => isDueDatePassed ? "#f00" : "#302d2c"} !important;
      font-size: 15.5px !important;
      font-style: normal;
      font-weight: 600 !important;
      line-height: normal !important;
      margin-bottom: 0 !important;
      white-space: nowrap !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
  `;
  const HeaderActionButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.35);
    background: rgba(255, 255, 255, 0.08);
    cursor: pointer;
    padding: 0;
  `;

  const normalizeWorksheetClasses = (worksheet, assignmentInfo, class_game_activity, userClasses) => {
    if (Array.isArray(assignmentInfo?.classes) && assignmentInfo.classes.length > 0) {
      return assignmentInfo.classes.map((c) => {
        const id = c?.id ?? c;
        const uc = Array.isArray(userClasses)
          ? userClasses.find((u) => String(u?.id) === String(id))
          : null;
        return {
          id,
          displayName: c?.displayName || uc?.displayName || uc?.name || "",
        };
      });
    }
    if (!Array.isArray(class_game_activity) || !worksheet?.id) {
      return [];
    }
    const seen = new Set();
    const out = [];
    class_game_activity.forEach((activity) => {
      if (activity?.type !== "worksheet") {
        return;
      }
      if (String(activity?.game_id) !== String(worksheet.id)) {
        return;
      }
      const cid = activity.classId ?? activity.class_id;
      if (!cid || seen.has(String(cid))) {
        return;
      }
      seen.add(String(cid));
      const uc = Array.isArray(userClasses)
        ? userClasses.find((u) => String(u?.id) === String(cid))
        : null;
      out.push({
        id: cid,
        displayName: uc?.displayName || uc?.name || "",
      });
    });
    return out;
  };
  
  const WorksheetClassStatusDropDown = ({ data, currentClass, onClassClick, loading }) => {
    const [open, setOpen] = useState(false);
  
    const items = data?.map((item, index) => ({
      key: String(index),
      label: (
        <div>
          <span>{item.displayName || ""}</span>
        </div>
      ),
      className: item.id === currentClass?.id ? "selected-class-item" : "",
      onClick: async ({ key }) => {
        const selectedItem = data[parseInt(key, 10)];
        if (!selectedItem || selectedItem.id === currentClass?.id) {
          setOpen(false);
          return;
        }
        if (onClassClick && !loading) {
          await onClassClick(selectedItem);
          setOpen(false);
        }
      },
    })) || [];
  
    const handleOpenChange = (newOpen) => {
      if (!loading) {
        setOpen(newOpen);
      }
    };
  
    return (
      <Space direction="vertical">
        <Space wrap>
          <Dropdown
            className="assignInfoStatus"
            menu={{ items }}
            arrow
            overlayClassName="class-dropdown-menu worksheet-class-dropdown"
            open={open}
            onOpenChange={handleOpenChange}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer" }}>
              {data?.length > 1
                ? "Assigned to multiple class"
                : "Assigned to single class"}
              {loading ? (
                <Loading size={16} />
              ) : (
                <KeyboardArrowDown style={{ fontSize: "medium" }} />
              )}
            </div>
          </Dropdown>
        </Space>
      </Space>
    );
  };
  
  
  export default function WorksheetAssignment({
    isAssigned = false,
    ActivityData,
    page,
    numberMasked,
    pageLearningModuleCount,
    worksheetData,
  }) {
    const [selectedOption, setSelectedOption] = useState(1);
    const [selectedLabel, setSelectedLabel] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [newName, setNewName] = useState("");
    const [nameUpdateLoading, setNameUpdateLoading] = useState(false);
    const [titleLoader, setTitleLoader] = useState(false);
    const showAlert = useAlert();
    const currentUser = useCurrentUser();
    const isTeacher = currentUser && currentUser?.role === "teacher";
    const isStudent = currentUser?.role === 'student';
    const dispatch = useDispatch();
    const isTablate = useIsTab();
    const bookId = useMemo(() => {
      return ActivityData?.chapter;
    }, [ActivityData]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteSelectedClassIds, setDeleteSelectedClassIds] = useState([]);
    const [shareModal, setShareModal] = useState(false);
    const [shareAction, setShareAction] = useState({ type: "", open: false });
    const listWorkSheet = useWorkSheetSelector();
    const [loader, setLoader] = useState(false);
    const currentClass = useCurrentClass();
    const booksAllList = useAllBook();
    const { class_game_activity } = useClassGameActivity();
    const userClasses = useUserClasses();
    const [classSwitchLoading, setClassSwitchLoading] = useState(false);
    const resources = useResources();
    const videos = useVideos();
    const [removeGrammerDrill, setRemoveGrammerDrill] = useState(false);
    const [cloneGrammarDrillOpen, setCloneGrammarDrillOpen] = useState(false);
    const [cloneGrammarDrillAssignment, setCloneGrammarDrillAssignment] = useState(null);
    const GetBookName = getBookDisplayName(
      booksAllList,
      bookId,
      true,
      videos,
      resources
    );
    const submissions = useClassSubmissions();
    const allDistrictTeacher = useAllDistrictTeacher();
    const worksheet_submission = useMemo(() =>
      Array.isArray(submissions)
        ? submissions.filter((k) => k && k?.assignmentType == "worksheet")
        : []
    );
    const { grammer_drill_assigned_class = [] } = useUI();
    const {redirectToBook} = useGetRedirectUrlForBook();
    const navigate = useNavigate();
    const worksheetSelector = useWorksheetView();
    const openPlay= useMemo(() => worksheetSelector?.open, [worksheetSelector?.open]);
  
  
    const filterListWorksheet = useMemo(() => {
  
      const worksheetsOnPage = listWorkSheet?.filter(w => w?.page_id == page) || [];
  
      const originalIdsWithClones = new Set();
      worksheetsOnPage.forEach((w) => {
        if (w?.shared_by) {
          originalIdsWithClones.add(w.shared_by);
        }
      });
  
      const assignedWorksheetIds = new Set();
      if (isStudent && Array.isArray(class_game_activity)) {
        class_game_activity.forEach((activity) => {
          if (activity.type === 'worksheet' && activity.game_id) {
            assignedWorksheetIds.add(activity.game_id);
          }
        });
      }
  
      const data = worksheetsOnPage.filter((item) => {
        if (isStudent) {
          const isAssigned = assignedWorksheetIds.has(item.id);
          if (!isAssigned) {
            return false;
          }
        }
  
        if (item?.shared_by) {
          return true;
        }
  
        if (item.user_id === currentUser?.id) {
          return true;
        }
  
        const hasClone = originalIdsWithClones.has(item.id);
  
        if (hasClone) {
          return false;
        }
  
        let shareList = [];
        if (Array.isArray(item.share_list)) {
          shareList = item.share_list;
        } else if (typeof item.share_list === 'string') {
          try {
            shareList = JSON.parse(item.share_list || '[]');
          } catch (e) {
            shareList = [];
          }
        }
  
        const isSharedWithUser = shareList.includes(currentUser?.id);
  
        if (isSharedWithUser) {
          return true;
        } else {
          return true;
        }
      });
      return data;
    }, [listWorkSheet, page, currentUser, class_game_activity]);

    const isLastWorksheetActivity = useMemo(() => {
      const list = Array.isArray(worksheetData)
        ? worksheetData
        : [];
      if (!ActivityData?.id || !list?.length) {
        return false;
      }
      const lastItem = list[list.length - 1];
      const lastId =
        lastItem != null && typeof lastItem === "object"
          ? lastItem.id
          : lastItem;
      return String(lastId) === String(ActivityData.id);
    }, [ActivityData?.id, worksheetData]);

    const isSharedWorksheet = useCallback((worksheet) => {
      if (!worksheet || !currentUser) return false;
      if (worksheet.shared_by) {
        return true;
      }
  
      return worksheet.user_id !== currentUser.id &&
        Array.isArray(worksheet.share_list) &&
        worksheet?.share_list?.includes(currentUser.id);
    }, [currentUser]);
  
    const getOriginalTeacherId = useCallback((worksheet) => {
      if (!worksheet || !currentUser) return null;
  
      if (worksheet.shared_by) {
        let config = worksheet.config;
        if (typeof config === 'string') {
          try {
            config = JSON.parse(config);
          } catch (e) {
            config = {};
          }
        }
        if (config && config.shared_by_user_id) {
          return config.shared_by_user_id;
        }
  
        const originalShared = listWorkSheet?.find((w) =>
          w.id === worksheet.shared_by
        );
        if (originalShared && originalShared.user_id !== currentUser.id) {
          return originalShared.user_id;
        }
      }
  
      if (worksheet.user_id !== currentUser.id &&
        Array.isArray(worksheet.share_list) &&
        worksheet?.share_list?.includes(currentUser.id)) {
        return worksheet.user_id;
      }
  
      return null;
    }, [listWorkSheet, currentUser]);
    const worksheetInfo = useMemo(() => {
      const wInfo = filterListWorksheet.find((k) => k.id == selectedOption);
      return wInfo;
    }, [filterListWorksheet, selectedOption]);
    const sharedByTeacher = useMemo(() => {
      if (!worksheetInfo) return null;
  
      if (!worksheetInfo.shared_by && !isSharedWorksheet(worksheetInfo)) {
        return null;
      }
  
      const teacherId = getOriginalTeacherId(worksheetInfo);
  
      if (!teacherId) return null;
  
      const teacher = allDistrictTeacher.find((t) => t.id === teacherId);
      if (teacher) {
        return `${teacher.firstName} ${teacher.lastName}`;
      }
      return null;
    }, [worksheetInfo, allDistrictTeacher, isSharedWorksheet, currentUser, getOriginalTeacherId]);
    const assignmentInfo = useMemo(() => {
      if (
        worksheetInfo &&
        worksheetInfo.id &&
        Array.isArray(class_game_activity) &&
        class_game_activity.length > 0
      ) {
        const activity = class_game_activity.find(
          (k) => k.game_id == worksheetInfo.id && k.classId == currentClass.id
        );
        if (activity) return activity;
        return {};
      }
      return {};
    }, [currentClass, worksheetInfo, class_game_activity]);
  
    const getWorksheetAssignmentInfo = (ActivityData) => {
        if (
            ActivityData &&
            ActivityData.id &&
            Array.isArray(class_game_activity) &&
            class_game_activity.length > 0
        ) {
            const activity = class_game_activity.find(
                (item) => item.game_id == ActivityData?.id && item.classId == currentClass.id
            );
            return activity || {};
        }
        return {};
    }
  
    const getWorksheetSubmission = useCallback((worksheetId) => (
      worksheet_submission.find((item) => item.assignmentId === worksheetId)
    ), [worksheet_submission]);
  
    const getWorksheetSharedByTeacher = useCallback((worksheet) => {
      if (!worksheet) return null;
      if (!worksheet.shared_by && !isSharedWorksheet(worksheet)) {
        return null;
      }
      const teacherId = getOriginalTeacherId(worksheet);
      if (!teacherId) return null;
      const teacher = allDistrictTeacher.find((item) => item.id === teacherId);
      return teacher ? `${teacher.firstName} ${teacher.lastName}` : null;
    }, [allDistrictTeacher, getOriginalTeacherId, isSharedWorksheet]);
  
    const worksheetCover = useMemo(() => {
      return GrammarDrillCover;
    }, [booksAllList, bookId, page]);
  
    useEffect(() => {
      if (filterListWorksheet && filterListWorksheet[0]) {
        const initialWorksheet = filterListWorksheet[0];
        setSelectedOption(initialWorksheet.id);
        setSelectedLabel(initialWorksheet.display_name);
        setNewName(initialWorksheet.display_name);
      }
    }, [filterListWorksheet]);
  
    const handleEditName = (worksheet = worksheetInfo) => {
      if (currentUser?.role === "student") return;
      const currentWorksheet = worksheet || worksheetInfo;
      const currentAssignmentInfo = getWorksheetAssignmentInfo(currentWorksheet);
      if (currentAssignmentInfo?.id) return;
      setSelectedOption(currentWorksheet?.id);
      setSelectedLabel(currentWorksheet?.display_name || "");
      setEditMode(true);
      setNewName(currentWorksheet?.display_name || "");
    };
  
    const handleSaveNewName = async () => {
      if (!newName.trim()) {
        showAlert("Practice name cannot be empty", "error");
        return;
      }
  
      if (nameUpdateLoading) {
        return;
      }
      try {
        setNameUpdateLoading(true);
  
        if (isSharedWorksheet(worksheetInfo)) {
          const originalWorksheetId = worksheetInfo?.shared_by || selectedOption;
  
          const cloneResponse = await dispatch(
            handleCloneWorksheet({
              worksheet_id: originalWorksheetId,
              user_id: currentUser?.id,
              display_name: newName.trim(),
            })
          );
  
          if (cloneResponse?.success && cloneResponse?.data?.id) {
            await dispatch(
              handleUpdateWorksheetName({
                id: cloneResponse.data.id,
                display_name: newName.trim(),
                user_id: currentUser?.id,
              })
            );
            await dispatch(
              handleListWorkSheet(bookId, currentUser?.role, currentUser?.id, null, null, null, null, currentClass?.id)
            );
            await dispatch(handleLearningModuleCount({
              chapter: bookId,
              userId: currentUser?.id,
              pageId: page,
            }));
            setSelectedOption(cloneResponse.data.id);
            setSelectedLabel(newName.trim());
            showAlert("Practice name updated successfully", "success");
          } else {
            showAlert(cloneResponse?.error || "Failed to clone worksheet", "error");
          }
        } else {
          if (worksheetInfo?.user_id !== currentUser?.id) {
            showAlert("You can only edit your own worksheets", "error");
            setEditMode(false);
            return;
          }
  
          const response = await dispatch(
            handleUpdateWorksheetName({
              id: selectedOption,
              display_name: newName.trim(),
              user_id: currentUser?.id,
            })
          );
  
          if (response?.success) {
            setSelectedLabel(newName.trim());
            showAlert("Practice name updated successfully", "success");
          } else {
            showAlert("Failed to update practice name", "error");
          }
        }
      } catch (error) {
        console.error("Error updating practice name:", error);
        showAlert("An error occurred while updating the practice name", "error");
      } finally {
        setNameUpdateLoading(false);
        setEditMode(false);
      }
    };
  
    const fetchData = async (id) => {
      const response = await dispatch(handleListQuestionOfWorksheet(id));
      return response;
    };
  
    const fetchCurrentSubmissionData = async (worksheetId, worksheetSubmission) => {
      try {
        if (!worksheetSubmission?.id) {
          const submitDataObj = {
            worksheet_id: worksheetId,
            answer: [],
            class_id: currentClass.id,
            student_id: currentUser.id,
            time_duration: 0,
            total_correct_answer: 0,
            total_wrong_answer: 0,
            finish_later: 0,
            complete: false,
            submissions: 0
          }
          await dispatch(
            handleSubmitWorksheetAssignment(submitDataObj)
          );
          dispatch(handleListUserSubmissionsByClass(currentUser?.id, currentClass?.id));
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    const hideShareModal = () => {
      setShareModal(false);
    };
  
    const onStartPrectice = async (worksheet, worksheetAssignmentInfo, for_grade, hasSubmission, is_practice_mode) => {
      setLoader(true);
      setSelectedOption(worksheet?.id);
      setSelectedLabel(worksheet?.display_name || "");
      let questionArray = [];
      const response = await fetchData(worksheet?.id);
      if (!is_practice_mode) {
        await fetchCurrentSubmissionData(worksheet?.id, hasSubmission);
      }
      console.log('response', response);
      if (Array.isArray(response)) {
        response.forEach((element, index) => {
          if (!element?.id) return;
          element.question.id = element?.question_id;
          const questionData = {
            ...element?.question,
            image: element?.image,
            answer_audio: element?.answer_audio,
            question_audio: element?.question_audio,
          };
          questionArray.push(questionData);
        });
  
        const isResuming = hasSubmission && hasSubmission.complete === false && !is_practice_mode;
        const resumeData = isResuming ? {
          activeIndex: hasSubmission.answers?.length || 0,
          studentSubmission: hasSubmission.answers || [],
          isCorrect: hasSubmission.answers?.filter(a => a.isCorrect)?.length || 0,
        } : null;
        await dispatch(
          setWorksheetView({
            open: true,
            questions: questionArray,
            title: worksheet?.display_name || "",
            GetBookName: GetBookName,
            bookId: numberMasked,
            assignmentInfo: worksheetAssignmentInfo,
            for_grade,
            has_submission: is_practice_mode,
            resumeData
          })
        );
      }
      setLoader(false);
    };
  
    const onStartPrecticeRef = useRef(onStartPrectice);
    onStartPrecticeRef.current = onStartPrectice;
    const gdIdAutoOpenedRef = useRef(null);
  
    useEffect(() => {
      if (currentUser?.role !== "student") {
        return;
      }
      const params = new URLSearchParams(window.location.search);
      const assignmentType = params.get("assignment_type");
      const worksheetIdFromAssignment =
        assignmentType === "worksheet"
          ? params.get("worksheet_id")
          : null;
      const worksheetTargetId = params.get("gd_id") || worksheetIdFromAssignment;
      if (!worksheetTargetId) {
        gdIdAutoOpenedRef.current = null;
        return;
      }
      if (gdIdAutoOpenedRef.current === worksheetTargetId) {
        return;
      }
      if (!ActivityData) {
        return;
      }
      const worksheetAssignmentInfo = getWorksheetAssignmentInfo(ActivityData);
      if (!worksheetAssignmentInfo?.id) {
        return;
      }
      const worksheetSubmission = getWorksheetSubmission(ActivityData?.id);
      const scheduleAt = worksheetAssignmentInfo?.scheduleAt;
      const dueDate = worksheetAssignmentInfo?.dueDate;
      const now = dayjs();
      const isWithinSchedule =
        scheduleAt && dueDate
          ? now.isAfter(dayjs(scheduleAt)) && now.isBefore(dayjs(dueDate))
          : true;
      const isIncomplete = worksheetSubmission && worksheetSubmission.complete === false;
      let assignmentLabel = "TAKE NOW";
      if (isIncomplete) {
        assignmentLabel = "RESUME";
      } else if (worksheetSubmission || !isWithinSchedule) {
        assignmentLabel = "EMPEZAR A PRACTICAR";
      }
      if (assignmentLabel !== "Take now" && assignmentLabel !== "Resume") {
        return;
      }
      const isAssigned = !!worksheetAssignmentInfo?.id;
      const isActive = !isAssigned || isWithinSchedule;
      const isPracticeMode = worksheetSubmission?.complete || !isWithinSchedule ? true : false;
      gdIdAutoOpenedRef.current = worksheetTargetId;
  
      const clearWorksheetAutoOpenParams = () => {
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.delete("gd_id");
        currentParams.delete("assignment_type");
        currentParams.delete("worksheet_id");
        const nextSearch = currentParams.toString();
        return `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ""}`;
      };
  
      void (async () => {
        await onStartPrecticeRef.current(
          ActivityData,
          worksheetAssignmentInfo,
          isActive && !worksheetSubmission?.complete,
          worksheetSubmission || null,
          isPracticeMode
        );
  
        if (openPlay) {
          const url = redirectToBook({
            chapter: worksheetAssignmentInfo.assignment?.chapter,
            page: worksheetAssignmentInfo.assignment?.page
          });
          navigate(url, { replace: true });
          return;
        }
  
        navigate(clearWorksheetAutoOpenParams(), { replace: true });
      })();
    }, [
      currentUser?.role,
      filterListWorksheet,
      getWorksheetAssignmentInfo,
      getWorksheetSubmission,
      navigate,
      openPlay,
      redirectToBook,
    ]);
  
    const renderPracticeButton = (worksheet, worksheetAssignmentInfo, worksheetSubmission) => {
      if (isTeacher) {
        return (
          <div
            className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"} cursor-pointer`}
            onClick={() => onStartPrectice(worksheet, worksheetAssignmentInfo, false, false)}
            style={{ opacity: loader || editMode ? 0.6 : 1, pointerEvents: loader || editMode ? 'none' : 'auto' }}
          >
            <img src={eyeBtnSvg} alt="" title="" />
            <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>{loader && selectedOption === worksheet?.id ? "Loading..." : "Preview"}</label>
          </div>
        );
      }
  
      const isAssigned = !!worksheetAssignmentInfo?.id;
      const scheduleAt = worksheetAssignmentInfo?.scheduleAt;
      const dueDate = worksheetAssignmentInfo?.dueDate;
      const now = dayjs();
      const isWithinSchedule =
        scheduleAt && dueDate
          ? now.isAfter(dayjs(scheduleAt)) && now.isBefore(dayjs(dueDate))
          : true;
      const isActive = !isAssigned || isWithinSchedule;
      const isDueDatePassed = dueDate && dayjs(dueDate).isBefore(dayjs()) && currentUser?.role === "student";
      const isIncomplete = worksheetSubmission && worksheetSubmission.complete === false ;
      const is_practice_mode = worksheetSubmission?.complete || !isWithinSchedule ? true : false;
      let assignmentLabel = "Take now";
      if (isIncomplete && !is_practice_mode) {
        assignmentLabel = "Resume";
      } else if (worksheetSubmission || !isWithinSchedule) {
        assignmentLabel = "Empezar a practicar";
      }
  
      return (
        <button
          className={`cursor-pointer ${currentUser?.role === "student" ? `assignTakeNow grammer-drill-student-btn ${assignmentLabel === "Empezar a practicar" ? "assignResume" : null}` : "asignarBtnCstm"}`}
          onClick={() => onStartPrectice(worksheet, worksheetAssignmentInfo, isActive && !worksheetSubmission?.complete, worksheetSubmission || null, is_practice_mode)}
          disabled={loader}
        >
          {loader && selectedOption === worksheet?.id ? "Loading..." : isAssigned ? assignmentLabel : "Asignar dfg df"}
        </button>
      );
    };
  
    const getAssignmentStatusLabel = (worksheetAssignmentInfo) => {
      if (!worksheetAssignmentInfo?.id) {
        return "Unassigned";
      }
      const assignedClasses = Array.isArray(worksheetAssignmentInfo?.classes)
        ? worksheetAssignmentInfo.classes.length
        : 0;
      return assignedClasses > 1 ? "Assigned to multiple class" : "Assigned to single class";
    };
  
    const handleWorksheetClassClick = useCallback(
      async (selectedClass) => {
        if (!selectedClass?.id) {
          return;
        }
        if (selectedClass.id === currentClass?.id) {
          return;
        }
        if (classSwitchLoading) {
          return;
        }
        setClassSwitchLoading(true);
        try {
          await dispatch(handleGetClass(selectedClass.id));
        } finally {
          setClassSwitchLoading(false);
        }
      },
      [currentClass?.id, classSwitchLoading, dispatch],
    );
    const handleNextWorksheet = async () => {
      try {
        const currentIndex = filterListWorksheet.findIndex(
          (item) => item.id === selectedOption
        );
        const nextIndex = (currentIndex + 1) % filterListWorksheet.length;
        const nextItem = filterListWorksheet[nextIndex];
        setSelectedOption(nextItem?.id);
        setSelectedLabel(nextItem?.display_name);
        const response = await fetchData(nextItem.id);
        let questionArray = [];
        if (Array.isArray(response)) {
          response.forEach((element) => {
            if (!element?.id) return;
            questionArray.push(element?.question);
          });
  
          await dispatch(setWorksheetView({ questions: questionArray }));
        }
      } catch (error) {
        console.log(error);
      }
    };
  
  
  
    const DeleteGrammarDrills = async () => {
      try{
        setDeleteLoading(true);
  
        const isItAssigned = class_game_activity?.find(
          (item) =>
            String(item.game_id) === String(selectedOption));
    
        const worksheetToDelete = filterListWorksheet?.find((w) => w?.id === selectedOption);
        if (worksheetToDelete && isSharedWorksheet(worksheetToDelete) && worksheetToDelete?.user_id !== currentUser?.id) {
          await dispatch(handleUnshareWorksheet(selectedOption, currentUser?.id));
        } else {
          await dispatch(handleDeleteWorksheet(selectedOption, currentClass?.id, worksheetToDelete, isItAssigned));
          // await dispatch(handleListWorkSheet(bookId, currentUser?.role, currentUser?.id, null, null, null, null, currentClass?.id));
        }
        setDeleteLoading(false);
        setDeleteModal(false);
        setDeleteSelectedClassIds([]);
    
        dispatch(handleLearningModuleCount({
          chapter: bookId,
          userId: currentUser?.id,
          pageId: page,
        }));
      }catch(error){
        console.log(error);
      }
    };
  
    const handleRemoveGrammerDrill = async (selectedClassIds = []) => {
      try {
        setDeleteLoading(true);
        const classIdsToDelete = Array.isArray(selectedClassIds) && selectedClassIds.length > 0
        ? selectedClassIds
        : (currentClass?.id ? [currentClass.id] : []);
        await dispatch(handleRemoveWorkSheet(ActivityData?.id, currentClass?.id, ActivityData, true, classIdsToDelete));
        setDeleteLoading(false);
        setRemoveGrammerDrill(false);
        setDeleteSelectedClassIds([]);
        // Promise.all([
        //   dispatch(
        //     handleListWorkSheet(bookId, currentUser?.role, currentUser?.id, null, null, null, null, currentClass?.id)
        //   ),
        //   dispatch(handleGetWorksheetAssignedClassIds(currentUser?.id, bookId)),
        // ])
        dispatch(handleLearningModuleCount({
          chapter: bookId,
          userId: currentUser?.id,
          pageId: page,
        }))
      } catch(error){
        console.log(error?.message, "error");
      }
    }
  
    const getWorksheetClasses = (userClasses, worksheet) => {
      try{
        if(grammer_drill_assigned_class?.length === 0 || userClasses?.length === 0) return [];
        if(worksheet?.id){
          const worksheetClasses = grammer_drill_assigned_class?.find((item) => item.worksheet_id === worksheet.id)?.class_ids || [];
          const assingedClasses =  userClasses?.filter((item) => worksheetClasses.includes(item.id));
          return assingedClasses;
        }
        return [];
      }catch(error){
        console.log(error);
        return [];
      }
    }
    const isEditingThisWorksheet = editMode && selectedOption === ActivityData?.id;
  
  
    // if (filterListWorksheet?.length === 0) return null;
    const currentAssignmentInfo = getWorksheetAssignmentInfo(ActivityData);
    const currentSharedByTeacher = getWorksheetSharedByTeacher(ActivityData);
    const isItAssigned = currentAssignmentInfo?.id;
    const currentSubmission = getWorksheetSubmission(ActivityData?.data?.id);
    
    const scheduleAt = currentAssignmentInfo?.scheduleAt;
    const dueDate = currentAssignmentInfo?.dueDate;
    const now = dayjs();
    const isWithinSchedule =
    scheduleAt && dueDate
      ? now.isAfter(dayjs(scheduleAt)) && now.isBefore(dayjs(dueDate))
      : true;
    const isIncompleteRibbon = currentSubmission && currentSubmission.complete === false;
    const is_practice_mode = currentSubmission?.complete || !isWithinSchedule ? true : false;
    let assignmentLabel = "Take now";
    if (isIncompleteRibbon && !is_practice_mode) {
      assignmentLabel = "Resume";
    } else if (currentSubmission || !isWithinSchedule) {
      assignmentLabel = "Empezar a practicar";
    }
    const statusClassesList = getWorksheetClasses(
        userClasses,
        ActivityData
      );
    const classList = statusClassesList;
    const displayName = currentAssignmentInfo?.displayName || ActivityData?.displayName || "Grammar Drill";
    return (
      <SentryWrap>
        <style>
          {`
            .worksheet-class-dropdown.class-dropdown-menu .ant-dropdown-menu-item.selected-class-item {
              background-color: #e6f7ff !important;
              color: #1890ff !important;
              font-weight: 600 !important;
            }
            .worksheet-class-dropdown.class-dropdown-menu .ant-dropdown-menu-item.selected-class-item:hover {
              background-color: #bae7ff !important;
            }
          `}
        </style>
        <DeleteModal
          message={ `Are you sure you want to delete '${selectedLabel}' Grammar Drill?`}
          deleteToggle={deleteModal}
          setDeleteToggle={setDeleteModal}
          loading={deleteLoading}
          onDelete={DeleteGrammarDrills}
          buttonTitle="Remove"
        />
        <DeleteModal
          message={`Are you sure you want to remove '${selectedLabel}' Grammar Drill?`}
          deleteToggle={removeGrammerDrill}
          setDeleteToggle={setRemoveGrammerDrill}
          loading={deleteLoading}
          onDelete={() => handleRemoveGrammerDrill(deleteSelectedClassIds)}
          extraContent={(()=> {
            const selectedGrammerDrill = filterListWorksheet?.find((w) => w?.id === selectedOption);
            const currentAssignmentInfo = getWorksheetAssignmentInfo(selectedGrammerDrill);
            const statusClassesList = getWorksheetClasses(
              userClasses,
              selectedGrammerDrill
            );
            const classList = statusClassesList;
            const hasMultipleClasses = classList.length > 1;
            return hasMultipleClasses ? (
              <div style={{ marginTop: 16, width: '100%', textAlign: 'left' }}>
                <div style={{ marginBottom: 8, fontSize: 12, fontWeight: 500 }}>Select classes to delete grammar drill from:</div>
                <div className="delete-assignment-class-select-wrap" style={{ maxHeight: 96, overflowY: 'auto', borderRadius: 6, border: '1px solid #d9d9d9', padding: '2px 11px 2px 4px', background: '#fff' }}>
                  <Select
                    variant="borderless"
                    mode="multiple"
                    placeholder="Choose classes"
                    value={deleteSelectedClassIds}
                    onChange={setDeleteSelectedClassIds}
                    options={classList.map((cls) => ({ value: cls.id, label: cls.displayName || cls.name || cls.id }))}
                    style={{ width: '100%' }}
                    maxTagCount={2}
                    className="delete-assignment-class-select"
                    maxTagPlaceholder={(omittedValues) => (
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '2px 8px',
                          margin: '2px 4px 2px 0',
                          background: '#e6f4ff',
                          border: '1px solid #91caff',
                          borderRadius: 6,
                          fontSize: 12,
                          color: '#1677ff',
                          cursor: 'default',
                          fontWeight: 500
                        }}
                      >
                        + {omittedValues.length} more
                      </span>
                    )}
                    optionRender={(option) => (
                      <div
                        style={{
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          lineHeight: 1.4,
                          padding: '2px 0'
                        }}
                      >
                        {option.data?.label ?? option?.label ?? ''}
                      </div>
                    )}
                    tagRender={({ label, closable, onClose }) => (
                      <span
                        title={label}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 4,
                          padding: '2px 8px',
                          margin: '2px 4px 2px 0',
                          background: '#f0f5ff',
                          border: '1px solid #adc6ff',
                          borderRadius: 6,
                          fontSize: 12,
                          maxWidth: 160,
                          boxSizing: 'border-box'
                        }}
                      >
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>{label}</span>
                        {closable && (
                          <span
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClose(); }}
                            onClick={onClose}
                            style={{ cursor: 'pointer', color: '#597ef7', fontWeight: 600, lineHeight: 1 }}
                            aria-label={`Remove ${label}`}
                          >
                            x
                          </span>
                        )}
                      </span>
                    )}
                    listHeight={280}
                    dropdownStyle={{ zIndex: 9999, minWidth: 320 }}
                    dropdownAlign={{ overflow: { adjustX: true, adjustY: true } }}
                    dropdownRender={(menu) => (
                      <>
                        <div
                          style={{
                            padding: '8px 12px',
                            borderBottom: '1px solid #f0f0f0',
                            cursor: 'pointer',
                            fontSize: 12,
                            fontWeight: 500,
                            color: '#1890ff'
                          }}
                          onClick={() => setDeleteSelectedClassIds(
                            deleteSelectedClassIds.length === classList.length
                              ? []
                              : classList.map((c) => c.id)
                          )}
                        >
                          {deleteSelectedClassIds.length === classList.length ? 'Clear all' : 'Select all'}
                        </div>
                        {menu}
                      </>
                    )}
                    notFoundContent={<span style={{ padding: 8, color: '#888' }}>No classes found</span>}
                  />
                </div>
                {deleteSelectedClassIds.length > 0 && (
                  <div style={{ marginTop: 6, fontSize: 11, color: '#666' }}>
                    {deleteSelectedClassIds.length} class{deleteSelectedClassIds.length !== 1 ? 'es' : ''} selected - grammar drill will be deleted from these only
                  </div>
                )}
              </div>
            ) : null;
          })()}
  
  
    disableConfirm={(() => {
            const selectedGrammerDrill = filterListWorksheet?.find((w) => w?.id === selectedOption);
            const currentAssignmentInfo = getWorksheetAssignmentInfo(selectedGrammerDrill);
            const classList = normalizeWorksheetClasses(
              selectedGrammerDrill,
              currentAssignmentInfo,
              class_game_activity,
              userClasses,
            );
            return classList.length > 1 && deleteSelectedClassIds.length === 0;
          })()}
        buttonTitle="Remove"
        />
        <MainSection $isLastWorksheetActivity={isLastWorksheetActivity} isAssigned={isAssigned}>
          {/* {filterListWorksheet.map((worksheet) => {
            return ( */}
              <div key={ActivityData?.id} style={{ width: '100%' }}>
                <Section className='cardTextWraper'>
                  <div className='cardlabelSet'>
                    <span className="" style={{ textTransform: 'uppercase', fontSize: 11 }}>{currentUser?.role === "teacher" ? "Práctica de gramática" : assignmentLabel}</span>
                  </div>
                   <Header>
                    {isEditingThisWorksheet ? (
                      <div
                        className="edit-name-container"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40%",
                          paddingBottom: "5px",
                        }}
                      >
                        <Input
                          value={newName}
                          onChange={(e) => setNewName(e.target.value)}
                          style={{
                            color: "#000",
                            background: "#fff",
                            border: "1px solid rgba(62, 95, 143, 0.35)",
                            borderRadius: "4px",
                            padding: "4px 8px",
                            width: "100%",
                          }}
                          onPressEnter={async (e) => {
                            e.preventDefault();
                            setTitleLoader(true);
                            await handleSaveNewName();
                            setTitleLoader(false);
                          }}
                          onBlur={async () => {
                            setTitleLoader(true);
                            await handleSaveNewName();
                            setTitleLoader(false);
                          }}
                          autoFocus
                          disabled={titleLoader || currentUser?.role === "student"}
                        />
                        {titleLoader && (
                          <Loading
                            size={14}
                            white={true}
                            style={{ marginLeft: "8px" }}
                          />
                        )}
                      </div>
                    ) : (
                      <>
                        <HeaderLeft style={{ cursor: "default" }}>
                          <TitleIcon src={titleIconSvg} alt="" />
                          <div style={{ minWidth: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                            <Tooltip title={displayName}>
                              <HeaderTitle>
                                {displayName}
                              </HeaderTitle>
                            </Tooltip>
                            {currentUser?.role === "teacher" && !currentAssignmentInfo?.id && (
                              <Edit
                                style={{
                                  color: "white",
                                  fontSize: "16px",
                                  marginLeft: "2px",
                                  flexShrink: 0,
                                }}
                              />
                            )}
                          </div>
                        </HeaderLeft>
                      </>
                    )}
                    <HeaderRight>
                      {currentUser?.role === "teacher" && (
  
                        <WorkSheetPrint
                          worksheetId={ActivityData?.id}
                          chapter={numberMasked}
                          from="ebook"
                        />
                      )}
                      
                     {currentUser?.role === "teacher" && !isSharedWorksheet(ActivityData) && !ActivityData?.shared_by && (
                        <div>
                            <HeaderActionButton
                              type="button"
                              onClick={async () => {
                                setSelectedOption(ActivityData?.id);
                                setSelectedLabel(ActivityData?.displayName || "");
                                await dispatch(
                                  fetchShareListAssignment({
                                    assignmentId: ActivityData?.id,
                                    activityType: 'worksheet',
                                    shareList: ActivityData?.share_list,
                                  }),
                                );
                                setShareModal(true);
                              }}
                            >
                              <img
                                src={shareIconSvg}
                                alt=""
                                title=""
                                style={{
                                  width: 17,
                                  height: 17,
                                  filter: "brightness(0) saturate(100%) invert(49%) sepia(73%) saturate(1292%) hue-rotate(206deg) brightness(96%) contrast(92%)",
                                }}
                              />
                            </HeaderActionButton>
                          <ShareNotesList
                            shareModal={shareModal}
                            hideShareModal={hideShareModal}
                            note_id={ActivityData?.id}
                            assignment={ActivityData}
                            type="worksheet"
                            bookId={bookId}
                            pageId={page}
                          />
                          <ShareAction
                            from="worksheet"
                            action={shareAction?.type}
                            open={shareAction?.open}
                            setOpen={setShareAction}
                            bookId={bookId}
                            pageId={page}
                            type="worksheet"
                          />
                        </div>
                      )}
                      {currentUser?.role === "teacher" && (
                        <Dropdown
                          trigger={['click']}
                          menu={{
                            items: [
                              ...(currentAssignmentInfo?.id ? [{
                                key: "remove-assigned-activity",
                                label: "Remove Activity",
                                onClick: () => {
                                  setSelectedOption(ActivityData?.id);
                                  setSelectedLabel(displayName || "");
                                  const assignedClassList = normalizeWorksheetClasses(
                                    ActivityData,
                                    currentAssignmentInfo,
                                    class_game_activity,
                                    userClasses,
                                  );
                                  setDeleteSelectedClassIds(
                                    assignedClassList?.length > 0
                                      ? assignedClassList.map((item) => item.id)
                                      : (currentClass?.id ? [currentClass.id] : [])
                                  );
                                  setRemoveGrammerDrill(true);
                                },
                              }] : []),
                              {
                                key: "delete-activity",
                                label: "Delete Activity",
                                onClick: () => {
                                  setSelectedOption(ActivityData?.id);
                                  setSelectedLabel(displayName || "");
                                  const assignedClassList = normalizeWorksheetClasses(
                                    ActivityData,
                                    currentAssignmentInfo,
                                    class_game_activity,
                                    userClasses,
                                  );
                                  setDeleteSelectedClassIds(
                                    assignedClassList?.length > 0
                                      ? assignedClassList.map((item) => item.id)
                                      : (currentClass?.id ? [currentClass.id] : [])
                                  );
                                  setDeleteModal(true);
                                },
                              },
                            ],
                          }}
                        >
                          
                            <IconButton style={{ padding: 0 }}>
                              <img style={{width: "17px", height: "17px"}} src={trashIconSvg} className='trashIcon' alt="" title="" />
                            </IconButton>
                       
                        </Dropdown>
                      )}
                       {currentUser?.role !== "teacher" ? (
                            <AssignmentTypeBanner>
                              <AssignmentTypeName>Grammar Drill</AssignmentTypeName>
                            </AssignmentTypeBanner>
                          ) : null}
                    </HeaderRight>
                  </Header>
                  {isItAssigned ?
                    <>
                      <AssignmentInfoRow>
                        <AssignmentInfoLeft>
                        {currentUser?.role === "student"  && (
                            <div className='cardDetail' style={{ marginBottom: 10}}>
                              <div className='cardDetailInr'>
                                <img src={lastSubSvg} alt="" title="" />
                                <p>Submissions:</p>
                              </div>
                              <GradeText className="assigned-class-text">
                                {currentSubmission?.submissions || "0"}
                              </GradeText>
                            </div>
  
                          )}
                          {currentAssignmentInfo?.scheduleAt ? (
                            <div className='cardDetail' style={{ marginBottom: 0 }}>
                              <div className='cardDetailInr'>
                                <img src={clockSvg} alt="" title="" />
                                <p>Start Date:</p>
                              </div>
                              <span>
                                {dayjs(currentAssignmentInfo?.scheduleAt).format("MMM DD, YYYY hh:mm A")}
                              </span>
                            </div>
                          ) : null}
                          {currentAssignmentInfo?.dueDate ? (
                            <div className='cardDetail' style={{ marginBottom: 0, marginTop: 10 }}>
                              <div className='cardDetailInr'>
                                <img src={dueDateSvg} alt="" title="" />
                                <p>Due Date:</p>
                              </div>
                              <span>
                                {dayjs(currentAssignmentInfo?.dueDate).format("MMM DD, YYYY hh:mm A")}
                              </span>
                            </div>
                          ) : null}
                          {currentUser?.role !== "student" && (
                            <div className='cardDetail' style={{ marginBottom: 0, marginTop: 10 }}>
                              <div className='cardDetailInr'>
                                <img src={statusSvg} alt="" title="" />
                                <p>Status:</p>
                              </div>
                              <div className="assigned-class-text">
                                {statusClassesList.length > 0 ? (
                                  <WorksheetClassStatusDropDown
                                    data={classList}
                                    currentClass={currentClass}
                                    onClassClick={handleWorksheetClassClick}
                                    loading={classSwitchLoading}
                                  />
                                ) : (
                                  getAssignmentStatusLabel(currentAssignmentInfo)
                                )}
                              </div>
                            </div>
                          )}
                          {currentUser?.role === "student" && currentSubmission?.grade !== undefined && currentSubmission?.grade !== null && (
                            <div className='cardDetail' style={{ marginBottom: 0, marginTop: 10 }}>
                              <div className='cardDetailInr'>
                                <img src={lastSubSvg} alt="" title="" />
                                <p>Grade:</p>
                              </div>
                              <GradeText className="assigned-class-text">
                                {currentSubmission?.grade >=0 ? currentSubmission?.grade : "-"}
                              </GradeText>
                            </div>
                          )}
                          
                          <StatusBadges
                            style={{
                              marginTop: 10,
                              flexDirection: 'row',
                              flexWrap: 'nowrap',
                              alignItems: 'center',
                              marginBottom: 10,
                            }}
                          >
                            {currentSharedByTeacher ? (
                              <Tooltip title={`Shared by ${currentSharedByTeacher}`}>
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                  <SharedByBadge>
                                    {`Shared by ${currentSharedByTeacher}`}
                                  </SharedByBadge>
                                </span>
                              </Tooltip>
                            ) : null}
                            {currentUser?.role !== "student" && (
                              <AssignedBadge>Assigned</AssignedBadge>
                            )}
                          </StatusBadges>
                        </AssignmentInfoLeft>
                        <BookCover isTeacher={currentUser?.role === "teacher"} src={worksheetCover} alt="" />
                      </AssignmentInfoRow>
                    </> :
                    <>
                      <div className='cardDetail' style={{ marginBottom: 0, marginTop: 10 }}>
                        <div className='cardDetailInr'>
                          <img src={statusSvg} alt="" title="" />
                          <p>Status:</p>
                        </div>
                        <div className="assigned-class-text">
                          {getAssignmentStatusLabel(currentAssignmentInfo)}
                        </div>
                      </div>
                      <BodyImg>
                        <BookCover isAssigned={currentAssignmentInfo?.scheduleAt}  isTeacher={currentUser?.role === "teacher"} src={worksheetCover} alt="" />
                      </BodyImg>
                      {currentSharedByTeacher ? (
                        <StatusBadges style={{ marginBottom: 10 }}>
                          <Tooltip title={`Shared by ${currentSharedByTeacher}`}>
                            <SharedByBadge>
                              {`Shared by ${currentSharedByTeacher}`}
                            </SharedByBadge>
                          </Tooltip>
                        </StatusBadges>
                      ) : null}
                    </>
                  }
                 <FooterActions>
                    {isTeacher ? (
                      <FooterRight className="footer-right">
                        <ActivityFormWorksheet
                          chapter={bookId}
                          page={page}
                          workSheetInfo={ActivityData}
                          assignmentInfo={currentAssignmentInfo}
                          onDisplayNameChange={(newName) => {
                            if (newName) {
                              if (selectedOption === ActivityData?.id) {
                                setSelectedLabel(newName);
                              }
                            }
                          }}
                        />
                      </FooterRight>
                    ) : null}
                    {renderPracticeButton(ActivityData, currentAssignmentInfo, currentSubmission)}
                    {isTeacher ? (
                      <Tooltip placement="top" title="Copy grammar drill to another book/page">
                        <div
                          className="iconLabel"
                          style={{
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2,
                          }}
                          onClick={() => {
                            setCloneGrammarDrillAssignment({
                              id: String(ActivityData?.id),
                              chapter: bookId,
                              bookId,
                              page,
                              typeId: 'worksheet',
                              displayName,
                              assignmentType: 'worksheet',
                            });
                            setCloneGrammarDrillOpen(true);
                          }}
                        >
                          <CopyAllOutlined style={{ fontSize: 20, color: '#3e5f8f' }} />
                        </div>
                      </Tooltip>
                    ) : null}
                  </FooterActions>
                </Section>
              </div>
            {/* );
          })} */}
        </MainSection>
        <PlayWorkSheet
          handleNextWorksheet={handleNextWorksheet}
          page={page}
          book_id={bookId}
          numberMasked={numberMasked}
        />
        {cloneGrammarDrillOpen && cloneGrammarDrillAssignment ? (
          <CloneActivityToPageModal
            open={cloneGrammarDrillOpen}
            onClose={() => {
              setCloneGrammarDrillOpen(false);
              setCloneGrammarDrillAssignment(null);
            }}
            assignment={cloneGrammarDrillAssignment}
            onSuccess={() => {
              void dispatch(
                handleListWorkSheet(
                  String(bookId),
                  currentUser?.role,
                  currentUser?.id,
                  null,
                  null,
                  null,
                  null,
                  currentClass?.id
                )
              );
              dispatch(
                handleLearningModuleCount({
                  chapter: bookId,
                  userId: currentUser?.id,
                  pageId: page,
                })
              );
            }}
          />
        ) : null}
      </SentryWrap>
    );
  }
  